/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : ACCOUNT ADD USER : STYLES --------------- ++++++++++ */
export default theme => ({
    adduser: {
    	extend: theme.modal.form,
        maxWidth: pxToEm(849),
        '& .permissionslabel':{
            marginBottom: pxToEm(15)
        }
    }
});
